import React, { useMemo, useRef } from "react";
import { Icon, RSelect } from "../../Component";

const FormTimePickerHours = ({ selected, onChange, placeholderText, disabled, ...props }) => {
  const dropdownRef = useRef();

  const hoursOptions = useMemo(
    () => [
      { value: "0", label: "No Cap Hours" },
      { value: "24", label: "24" },
      { value: "48", label: "48" },
    ],
    []
  );

  const selectedOption = useMemo(() => {
    return hoursOptions.find((option) => option.value === (selected ?? "").toString()) || null;
  }, [selected, hoursOptions]);

  const handleSelectChange = (option) => {
    onChange(option?.value);
  };

  return (
    <div className="form-control-wrap h-50">
      <div className="input-group">
        <div className="input-group-prepend w-100">
          <Icon className="input-group-text" name="clock" />
          <div className="w-100">
            <RSelect
              ref={dropdownRef}
              options={hoursOptions}
              placeholder={placeholderText || "Select Hour"}
              value={selectedOption}
              isClearable={false}
              isDisabled={disabled ?? false}
              onChange={handleSelectChange}
              {...props}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormTimePickerHours;
